import tokens from './tokens.json';

export type ThemeMode = 'default' | 'light' | 'dark' | 'accessible';

type ThemeVars = Record<string, string>;

const buildVars = (mode: ThemeMode): ThemeVars => ({
  '--color-navbar-bg': tokens.semantic[mode].navbarBg,
  '--color-bg': tokens.semantic[mode].background,
  '--color-surface': tokens.semantic[mode].surface,
  '--color-surface-subtle': tokens.semantic[mode].surfaceSubtle,
  '--color-surface-hover': tokens.semantic[mode].surfaceHover,
  '--color-text': tokens.semantic[mode].text,
  '--color-muted': tokens.semantic[mode].muted,
  '--color-muted-subtle': tokens.semantic[mode].mutedSubtle,
  '--color-border': tokens.semantic[mode].border,
  '--color-primary': tokens.semantic[mode].primary,
  '--color-primary-hover': tokens.semantic[mode].primaryHover,
  '--color-primary-bg': tokens.semantic[mode].primaryBg,
  '--color-on-primary': tokens.semantic[mode].onPrimary,
  '--color-success': tokens.semantic[mode].success,
  '--color-success-bg': tokens.semantic[mode].successBg,
  '--color-warning': tokens.semantic[mode].warning,
  '--color-warning-bg': tokens.semantic[mode].warningBg,
  '--color-info': tokens.semantic[mode].info,
  '--color-info-bg': tokens.semantic[mode].infoBg,
  '--color-danger': tokens.semantic[mode].danger,
  '--color-danger-bg': tokens.semantic[mode].dangerBg,
  '--color-danger-hover': tokens.semantic[mode].dangerHover,
  '--color-backdrop-secondary': tokens.semantic[mode].backdropSecondary,
  '--color-code-editor-bg': tokens.semantic[mode].codeEditorBg,
  '--color-code-editor-text': tokens.semantic[mode].codeEditorText,
  '--color-inactive': tokens.semantic[mode].inactive,
  '--color-icon-hover': tokens.semantic[mode].iconHover,
  '--color-category-badge-text': tokens.semantic[mode].categoryBadgeText,
  '--color-category-audience': tokens.semantic[mode].categoryAudience,
  '--color-category-money': tokens.semantic[mode].categoryMoney,
  '--color-category-front-of-house': tokens.semantic[mode].categoryFrontOfHouse,
  '--color-category-platform': tokens.semantic[mode].categoryPlatform,
});

export const themeVars = {
  default: buildVars('default'),
  light: buildVars('light'),
  dark: buildVars('dark'),
  accessible: buildVars('accessible'),
};

export const applyThemeVars = (mode: ThemeMode, root: HTMLElement = document.documentElement) => {
  const vars = themeVars[mode];
  Object.entries(vars).forEach(([key, value]) => {
    root.style.setProperty(key, value);
  });
  root.classList.toggle('dark', mode === 'dark');
  root.setAttribute('data-theme', mode);
};
